import * as React from "react";
import Modal from "react-responsive-modal";
import { AsyncCreatable, Option, Options } from "react-select";
import "react-select/dist/react-select.css";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import "./EmailQuoteModal.css";

interface Props {
    onSubmit: Function;
}

interface State {
    isModalOpen: boolean;
    sender: string;
    customerId?: number;
    customerName: string;
    recipients: Options;
    ccs: Options;
    bccs: Options;
    subject: string;
    message: string;
    errorMessage?: string;
}

export default class EmailQuoteModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isModalOpen: false,
            sender: "",
            customerName: "",
            recipients: [],
            ccs: [],
            bccs: [],
            subject: "",
            message: "",
            errorMessage: undefined,
        };

        this.getContacts = this.getContacts.bind(this);
        this.handleRecipientsChanged = this.handleRecipientsChanged.bind(this);
        this.handleCcsChanged = this.handleCcsChanged.bind(this);
        this.handleBccsChanged = this.handleBccsChanged.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <Modal
                open={this.state.isModalOpen}
                onClose={this.handleClose}
                little
                classNames={{ overlay: "modal-overlay" }}
                closeOnOverlayClick={false}
            >
                <div className="vertical-alignment-helper">
                    <div
                        className="modal-dialog modal-lg vertical-align-center"
                        role="document"
                    >
                        <div className="card card--form">
                            <div className="card-block">
                                {this.state.errorMessage && (
                                    <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>
                                )}
                                <form name="form" className="form" onSubmit={this.handleSubmit}>
                                    <div className="field-group">
                                        <span className="field-label">From:</span>
                                        <span className="field-item">{this.state.sender}</span>
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">To:</span>
                                        <AsyncCreatable
                                            multi
                                            value={this.state.recipients}
                                            onChange={this.handleRecipientsChanged}
                                            placeholder=""
                                            isLoading={true}
                                            promptTextCreator={(label) => `Add email "${label}"`}
                                            loadOptions={this.getContacts}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">CC:</span>
                                        <AsyncCreatable
                                            multi
                                            value={this.state.ccs}
                                            onChange={this.handleCcsChanged}
                                            placeholder=""
                                            isLoading={true}
                                            promptTextCreator={(label) => `Add email "${label}"`}
                                            loadOptions={this.getContacts}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">BCC:</span>
                                        <AsyncCreatable
                                            multi
                                            value={this.state.bccs}
                                            onChange={this.handleBccsChanged}
                                            placeholder=""
                                            isLoading={true}
                                            promptTextCreator={(label) => `Add email "${label}"`}
                                            loadOptions={this.getContacts}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Subject:</span>
                                        <input
                                            type="text"
                                            name="subject"
                                            className="form-control"
                                            value={this.state.subject}
                                            onChange={this.handleInputChanged}
                                        />
                                    </div>
                                    <div className="field-group">
                                        <span className="field-label">Message:</span>
                                        <textarea
                                            rows={6}
                                            name="message"
                                            className="form-control"
                                            value={this.state.message}
                                            onChange={this.handleInputChanged}
                                        ></textarea>
                                    </div>
                                    <div className="form-actions">
                                        <div className="text-center">
                                            <button type="submit" className="btn btn-primary">
                                                Send Quote
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    async getContacts(input: string) {
        if (!input) {
            return {
                options: [],
            };
        }

        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            `quotes/email/search?query=${encodeURIComponent(input)}`,
            undefined,
            true
        );
        if (response.ok) {
            let data = await response.json();
            return {
                options: data.map((x: { name: string; email: string }) => ({
                    value: x.email,
                    label: `${x.name} (${x.email})`,
                })),
            };
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    handleRecipientsChanged(newValue: Option | Options | null) {
        this.setState({
            recipients: newValue as Options,
        });
    }

    handleCcsChanged(newValue: Option | Options | null) {
        this.setState({
            ccs: newValue as Options,
        });
    }

    handleBccsChanged(newValue: Option | Options | null) {
        this.setState({
            bccs: newValue as Options,
        });
    }

    handleInputChanged(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    handleClose() {
        this.setState({
            isModalOpen: false,
            sender: "",
            customerId: undefined,
            customerName: "",
            recipients: [],
            ccs: [],
            bccs: [],
            subject: "",
            message: "",
            errorMessage: undefined,
        });
    }

    handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.props.onSubmit(
            {
                sender: this.state.sender,
                recipients: this.state.recipients.map((x) => x.value),
                ccs: this.state.ccs.map((x) => x.value),
                bccs: this.state.bccs.map((x) => x.value),
                subject: this.state.subject,
                message: this.state.message,
            },
            this.state.customerId
        );

        this.handleClose();
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/EmailQuoteModal.tsx